import React, { useEffect, useState } from 'react';
import { RootState } from '../../../reducers';
import { bindActionCreators, Dispatch } from 'redux';
import * as actions from '../../../actions';
import * as _actionsSearch from '../../../actions/search';
import * as _actionsProduct from '../../../actions/product';
import * as _actionsFilters from '../../../actions/filters';
import * as _actionsJourney2 from '../../../actions/journey2';
import * as _actionsBasket from '../../../actions/basket';
import { withRouter } from '../../../utils/withRouter';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';
import { getParameterByName } from '../../../utils/toSearchParams';
import './ProductDetail.scss';
import { createDateRange, formatNumber, parseToApiDate } from '../../../utils/react';
import { prepareAddToBasketPayload } from '../../../utils/payloads';
import { createBasket, removeFromBasket } from '../../../utils/basket';
import ErrorContainer from '../../ErrorContainer/ErrorContainer';
import { defined } from '../../../utils/variableEvaluation';
import { useNavigate } from 'react-router';
import { parseISO } from 'date-fns';
import Spinner from '../../Spinner';
import { ReactComponent as Check } from '../../../assets/icons/check.svg';
import { ReactComponent as RedxIcon, ReactComponent as RedX } from '../../../assets/icons/redX.svg';
import { ReactComponent as GreenChecker } from '../../../assets/icons/green_checker.svg';
import { formatDate, getBasketDateFromProduct, getDateFromProduct } from '../../../utils/product';
import { ReactComponent as Edit } from '../../../assets/icons/edit.svg';
import { ReactComponent as WhiteSearch } from '../../../assets/icons/white-search.svg';
import parse from 'html-react-parser';
import { SchemaAddToBasketResponse, SchemaNewBasketResponse, SchemaProduct } from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  location: any;
  actionsProduct: typeof _actionsProduct;
  userDataEC: PartiallyIntegratedUserDataEC;
  intl: any;
  actionsJourney2: typeof _actionsJourney2;
  product: any;
  journey2: any;
  productNew: any;
  productsJ2: SchemaProduct[];
  loading: Object;
  possibleBookingDates: any;
  actionsBasket: typeof _actionsBasket;
  errors: any;
  notices: any;
  nextProduct: (SchemaProduct & { idx: number }) | null;
  prevProduct: (SchemaProduct & { idx: number }) | null;
  productsJ2ByUrn: Record<string, SchemaProduct>;
}

const ProductDetailModal = ({
  location,
  actionsProduct,
  userDataEC,
  intl,
  journey2,
  possibleBookingDates,
  actionsBasket,
  productNew,
  errors,
  notices,
  productsJ2ByUrn,
}: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dateRange, setDateRange] = useState([
    createDateRange(new Date(userDataEC.startDate) || new Date(), userDataEC.duration || 7, {
      toEndOfYear: false,
      fullWeeks: true,
    }),
  ]);
  const [duration, setDuration] = useState(userDataEC.duration || 7);
  const [isInBasket, setIsInBasket] = useState(true);

  const { ui, basketProducts } = userDataEC;

  const [product, setProduct] = useState<any>({});

  const isHideActions = getParameterByName('isHideActions', location.search) === 'true';

  const navigate = useNavigate();

  const openFastbookModalForMissingParameter = (producturn: string) => {
    navigate({ search: `?modalContent=fastbook&urn=${producturn}&missingparameter=1` });
  };

  const hasMissingParameter: boolean = !userDataEC.startDate || !userDataEC.industry;

  useEffect(() => {
    const _urn = getParameterByName('urn', location.search);
    if (_urn) {
      let startRangeDate: Date;
      if (userDataEC.startDate) {
        startRangeDate = new Date(userDataEC.startDate);
      } else if (possibleBookingDates && possibleBookingDates['start']) {
        startRangeDate = parseISO(possibleBookingDates['start'].date);
      } else {
        startRangeDate = new Date();
      }

      let initialDuration = userDataEC.duration || 7;
      actionsProduct
        .fetchProductByUrn({
          urn: encodeURI(_urn),
          date: parseToApiDate(startRangeDate),
          duration: (userDataEC?.duration || 7).toString(),
        })
        .then((res: any) => {
          // should be SchemaProductResponse -> OpenAPI model is not clean enough, includes unknown.
          const isProductInBasket =
            Object.keys(basketProducts.productsByUrnDate).includes(res.data.basketkey) && basketProducts.products;
          if (isProductInBasket) {
            setIsInBasket(true);
            startRangeDate = parseISO(basketProducts.productsByUrnDate[res.data.basketkey].startdate);
            setProduct(basketProducts.productsByUrnDate[res.data.basketkey]);
            // @ts-expect-error Open API spec mismatch: duration does not exist on type:
            initialDuration = basketProducts.productsByUrnDate[res.data.basketkey].duration;
          } else {
            res.data.startdate = startRangeDate;
            setIsInBasket(false);
            setProduct(res.data);
            const minDays = res.data?.mindays;
            const maxDays = res.data?.maxdays;
            initialDuration = minDays && initialDuration < minDays ? minDays : initialDuration;
            initialDuration = maxDays && initialDuration > maxDays ? maxDays : initialDuration;
          }

          setDuration(initialDuration);
          const range = createDateRange(startRangeDate, initialDuration, {
            toEndOfYear: false,
            fullWeeks: true,
          });
          setDateRange([range]);
          setIsLoading(false);
        })
        .catch((error: any) => {
          console.log(error);
        });
    }
  }, [location]);

  const addToBasket = (basketData: { basket: number; basketreference: string }) => {
    const { basket, basketreference } = basketData;
    let payload;
    payload = prepareAddToBasketPayload(
      basket,
      basketreference,
      parseToApiDate(dateRange[0].startDate),
      duration,
      product.producturn,
      userDataEC.industry,
    );

    if (hasMissingParameter) {
      openFastbookModalForMissingParameter(product.producturn);
      return;
    }

    return actionsBasket
      .addToBasket(payload)
      .then((res: SchemaAddToBasketResponse) => {
        if (res) {
          actionsBasket
            .getBasketContent(basketData)
            .then(() => {
              setIsLoading(false);
              closeModal();
            })
            .catch((err: any) => {
              console.error(err);
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const addOrCreateBasket = () => {
    setIsLoading(true);
    if (userDataEC.basketInfo) {
      if (isInBasket) {
        return removeFromBasket(
          // @ts-expect-error Open API spec mismatch: basketentryid does not exist on type (basketentryId does, capital I):
          userDataEC.basketProducts.productsByUrn[product.producturn].basketentryid,
          userDataEC,
          actionsBasket,
          product.producturn,
        ).then(() => {
          return addToBasket(userDataEC.basketInfo);
        });
      } else {
        return addToBasket(userDataEC.basketInfo);
      }
    } else {
      return createBasket(userDataEC, dateRange[0].startDate, actionsBasket).then((res: SchemaNewBasketResponse) => {
        return addToBasket({
          basket: res.data.basket,
          basketreference: res.data.basketreference,
        });
      });
    }
  };

  const closeModal = () => {
    setProduct({});
    setIsInBasket(false);
    navigate({ search: '' });
  };

  const getProductState = () => {
    return defined(productsJ2ByUrn[product?.producturn]?.state)
      ? productsJ2ByUrn[product.producturn].state
      : product.state;
  };

  const getProductSpotLengthNumber = () => {
    let spotLength = null;

    if (productNew && productNew.basketspotlength) {
      spotLength = productNew.basketspotlength;
    } else if (product && product.spotlength) {
      spotLength = product.spotlength;
    }

    return spotLength || 10;
  };

  const getProductSpotLength = () => {
    let spotLength = getProductSpotLengthNumber();

    return !!spotLength
      ? `${spotLength} ${intl.formatMessage({
          id: 'ec.general.seconds',
          defaultMessage: 'Sekunden',
        })}`
      : '';
  };

  const getDailyBroadcasts = () => {
    if (product.producttype === 'digital') {
      if (productNew) {
        return productNew.basketdailytransmission;
      } else {
        return productsJ2ByUrn[product.producturn].dailytransmission || product.dailytransmission;
      }
    } else {
      return productNew?.basketdailytransmission ? productNew.basketdailytransmission : product.basketdailytransmission;
    }
  };

  const getTotalBroadcasts = () => {
    if (product.producttype === 'digital') {
      if (productNew) {
        return productNew.baskettotaltransmission;
      } else {
        return productsJ2ByUrn[product.producturn].weeklytransmission || product.weeklytransmission;
      }
    } else {
      return productNew?.baskettotaltransmission ? productNew.baskettotaltransmission : product.weeklytransmission;
    }
  };

  const getRepetitions = () => {
    if (product?.producttype === 'digital') {
      if (productNew) {
        return productNew?.basketdailyrepetition || productNew?.dailyrepetition;
      } else {
        return productsJ2ByUrn[product?.producturn]?.dailyrepetition || product?.dailyrepetition;
      }
    } else {
      return productNew?.basketdailyrepetition ? productNew.basketdailyrepetition : product.dailyrepetition;
    }
  };

  const getPrice = () => {
    let price = 0;
    if (product.producttype === 'digital') {
      if (productNew) {
        return productNew.pricefordates?.length > 0 ? productNew.pricefordates[0].price : productNew.standardprice;
      } else {
        price =
          productsJ2ByUrn[product.producturn].pricefordates?.length > 0
            ? productsJ2ByUrn[product.producturn].pricefordates[0].price
            : product.standardprice;
      }
    } else {
      price = productNew?.standardprice ? productNew.standardprice : product.standardprice;
    }

    return formatNumber(price, 2);
  };

  const isProductInBasket = journey2 && productNew?.state == 0;
  const productState = getProductState();
  const basketDate = getBasketDateFromProduct(productNew);
  const productDate = getDateFromProduct(product);
  const _startDate =
    !!dateRange && dateRange[0] && dateRange[0].startDate && formatDate(dateRange[0].startDate, '', intl.locale);
  const endDate =
    !!dateRange && dateRange[0] && dateRange[0].endDate && formatDate(dateRange[0].endDate, '', intl.locale);
  const startDateBasket = !!basketDate
    ? formatDate(basketDate[0], '', intl.locale)
    : !!productDate
      ? formatDate(productDate[0], '', intl.locale)
      : '';
  const endDateBasket = !!basketDate
    ? formatDate(basketDate[1], '', intl.locale)
    : !!productDate
      ? formatDate(productDate[1], '', intl.locale)
      : '';
  const startDateProduct = !!productDate ? formatDate(productDate[0], '', intl.locale) : null;
  const endDateProduct = !!productDate ? formatDate(productDate[1], '', intl.locale) : null;
  const isDigital = product?.producttype === 'digital';
  const spotLength = product.producttype === 'digital' ? getProductSpotLength() : '';
  const spotLengthTermin = isDigital ? '' : spotLength;
  const dailyRepetitions = getRepetitions();

  return (
    <div
      className={classNames('productDetailModal', {
        modalLoading: isLoading,
      })}
      id='root'
    >
      {isLoading && <Spinner />}

      <div className={classNames('modalHeader border-bottom d-flex justify-content-between align-items-start h-auto')}>
        <div className='d-flex flex-column justify-content-center gap-2'>
          <div className='font-24 font-bold'>
            {product?.format ? product.format + ' - ' + product?.name : product?.name}
          </div>
          <div className='d-flex justify-content-start align-items-center'>
            {product?.mediainfo?.nummer && (
              <div className='product-id'>
                <div className='badge bg-light product-code'>
                  <span>ID: {product?.mediainfo?.nummer}</span>
                </div>
              </div>
            )}

            {productState >= 0 && (
              <div className='product-state'>
                <div className='d-flex align-items-center'>
                  {productState === 0 && (
                    <div className='d-flex justify-content-start ms-4 availability'>
                      <span className='green-checker ps-0'>
                        <Check />
                      </span>
                      <span className='ps-0 font-14 font-600'>
                        {intl.formatMessage({
                          id: 'ec.journey02.available',
                          defaultMessage: 'Verfügbar',
                        })}
                      </span>
                    </div>
                  )}
                  {productState > 0 && (
                    <div className='d-flex justify-content-start ms-4 availability'>
                      <span className='unavailable-checker ps-0'>
                        <RedX />
                      </span>

                      <span className='ps-0 font-14 font-600'>
                        {intl.formatMessage({
                          id: 'ec.journey02.unavailable',
                          defaultMessage: 'Nicht verfügbar',
                        })}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='close-modal align-items-start justify-content-start'>
          <Button onClick={closeModal} className='mt-0'>
            <RedxIcon />
          </Button>
        </div>
      </div>

      <div className={classNames('modalBody h-100')}>
        {(errors?.length || notices?.length) && (
          <ErrorContainer
            getDataFromRedux={true}
            journeyType={'journey02'}
            classNameErrorWrapper={'mw-100 m-0 mt-3'}
            classNameErrorContainer={'m-0'}
          />
        )}

        <div className='product-image-wrapper border-bottom'>
          <div className='product-image'>
            <Button
              className='search-box d-flex justify-content-center align-items-center'
              buttonType={EButtonType.BasicLink}
              onClick={() =>
                navigate({
                  search: `?modalContent=productImage&urn=${product.producturn}&redirect=product&isHideActions=true`,
                })
              }
            >
              <WhiteSearch />
            </Button>
            <div className='code-product'>{product?.mediainfo?.nummer}</div>
            {product?.productphotopath && (
              <img alt='Product' src={product?.productphotopath + '&resolution=preview?'} />
            )}
          </div>

          {product?.producttype === 'digital' && (
            <div className='product-info'>
              <div className='product-icon'>{KitIcons.getProductIcon(product)}</div>
              <div className='details'>
                <div className='detail-item'>
                  <span className='label'>
                    <FormattedMessage id='ec.general.digiflexLength' defaultMessage='Länge' />
                  </span>
                  : <span className='label-value'>{spotLength}</span>
                </div>
                <div className='detail-item'>
                  <span className='label'>
                    <FormattedMessage
                      id='ec.general.digiflexDailyBroadcasts'
                      defaultMessage='Tägliche Ausstrahlungen'
                    />
                  </span>
                  : <span className='label-value'>{getDailyBroadcasts()}</span>
                </div>
                <div className='detail-item'>
                  <span className='label'>
                    <FormattedMessage id='ec.modals.digiflex.weeklyBroadcasts' defaultMessage='Total Ausstrahlungen' />
                  </span>
                  : <span className='label-value'>{getTotalBroadcasts()}</span>
                </div>
              </div>
            </div>
          )}
        </div>

        {isDigital && (
          <div className='broadcast-details pb-24 border-bottom mb-48'>
            <div className='col d-flex align-items-end justify-content-start product-details p-0'>
              <div className='col d-flex flex-column align-items-start font-14 p-0'>
                <b className='mb-3 font-16'>
                  <FormattedMessage id='ec.general.digiflexDailyBroadcasts' defaultMessage='Tägliche Ausstrahlungen' />
                </b>
                <span>{getDailyBroadcasts()}</span>
              </div>
              <div className='col d-flex flex-column align-items-start font-14 p-0'>
                <b className='mb-3 font-16'>
                  <FormattedMessage id='ec.modals.digiflex.weeklyBroadcasts' defaultMessage='Total Ausstrahlungen' />
                </b>
                <span>{getTotalBroadcasts()}</span>
              </div>

              <div className='col d-flex flex-column align-items-start font-14 p-0'>
                <b className='mb-3 font-16'>
                  <FormattedMessage id='ec.modals.digiflex.spotlength' defaultMessage='Spot duration' />
                </b>
                <span>{spotLength}</span>
              </div>

              <div className='col d-flex flex-column align-items-start font-14 p-0'>
                <b className='mb-3 font-16'>
                  <FormattedMessage id='ec.general.repetitions' defaultMessage='Repetition' />
                </b>
                <span>{dailyRepetitions}</span>
              </div>
            </div>
          </div>
        )}

        <div className='col d-flex align-items-start justify-content-start product-details p-0'>
          <div className='col d-flex flex-column align-items-start font-14 p-0'>
            <b className='mb-3 font-16'>
              <FormattedMessage id='ec.general.address' defaultMessage='Adresse' />
            </b>
            {product.address && <span>{parse(product.address)}</span>}
          </div>
          <div className='col d-flex flex-column align-items-start font-14 p-0'>
            <b className='mb-3 font-16'>
              <FormattedMessage id='ec.components.productsTable.termin' defaultMessage='Termin' />
            </b>
            {(userDataEC?.startDate || isProductInBasket) && (
              <>
                <span className='d-flex align-items-start'>
                  <div className=''>{productState === 0 && <GreenChecker className='green-checker' />}</div>
                  <div className='d-flex flex-column align-items-start'>
                    <span>
                      <FormattedMessage
                        id='ec.general.daysAndSpotLength'
                        defaultMessage='{duration} Tage{spotLength}'
                        values={{
                          duration: isProductInBasket ? productNew.duration : product.duration || duration,
                          spotLength: spotLengthTermin,
                        }}
                      />
                    </span>
                    <span>
                      {startDateProduct || _startDate} {`- ${endDateProduct || endDate}`}
                    </span>
                    <Button
                      buttonType={EButtonType.BasicLink}
                      className='mt-0 d-flex align-items-center'
                      onClick={() => {
                        if (isDigital) {
                          navigate({
                            search: `?modalContent=digiflex&urn=${product.producturn}&redirect=product&basketkey=${isProductInBasket ? product.basketkey : null}`,
                          });
                        } else {
                          navigate({
                            search: `?modalContent=analog&urn=${product.producturn}&redirect=product&basketkey=${isProductInBasket ? product.basketkey : null}`,
                          });
                        }
                      }}
                    >
                      <Edit className='editIcon me-2' /> Edit
                    </Button>
                  </div>
                </span>

                <></>
              </>
            )}
          </div>
          <div className='col d-flex flex-column align-items-end font-16 font-bold'>
            <b className='mb-24 font-16'>CHF</b>
            <span>{getPrice()}</span>
          </div>
        </div>
      </div>

      <div className={classNames('modalFooter border-top d-flex w-100 h-auto bg-white flex-column')}>
        <div
          className={classNames('d-flex align-items-center', {
            'justify-content-end': !ui.isMobile,
            'justify-content-between': ui.isMobile,
          })}
        >
          <Button buttonType={EButtonType.BasicLink} className='mt-0 ' onClick={closeModal}>
            <FormattedMessage id='ec.components.buttons.cancel' defaultMessage='Abbrechen' />
          </Button>

          {!isHideActions && (
            <Button
              buttonType={EButtonType.InvertedPillMedium}
              className='mt-0 ms-24 text-uppercase'
              isDisabled={isLoading || errors.length > 0 || notices.length > 0}
              isLoading={isLoading}
              onClick={() => {
                addOrCreateBasket();
              }}
            >
              {isInBasket ? (
                <FormattedMessage id='ec.components.buttons.updateInBasket' defaultMessage='Update' />
              ) : (
                <FormattedMessage id='ec.components.buttons.addToBasket' defaultMessage='Zum Warenkorb hinzufügen' />
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsSearch: bindActionCreators(_actionsSearch as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsProduct: bindActionCreators(_actionsProduct as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProductDetailModal)));
